export const parseJwt = (token: string) => {
	try {
		const base64Url = token.split('.')[1];
		const base64 = base64Url.replaceAll('-', '+').replaceAll('_', '/');
		const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
		const jsonPayload = atob(padded);
		return JSON.parse(jsonPayload);
	} catch (error) {
		console.error('Invalid token:', error);
		return null;
	}
};
